export default {
	title: 'Mon calendrier de suivi',
	datePresumee : 'Date présumée de mon accouchement',
	lien: 'Télécharger',
	lienRetour: {
		firstPart: 'Retour à l\'espace ',
		secondPart: 'J\'attends un enfant'
	},
	periodePec100 : {
		title: 'Période de prise en charge à 100%',
		periode: 'Du <span class="font-weight-bold">{0}</span> au <span  class="font-weight-bold">{1}</span>',
		mention: 'Les sept examens prénataux obligatoires sont pris en charge à 100% dès le début de la grossesse.'
	}
}